// The game's middlegame result, from how the middlegame started and how it
// ended (Ahead, Comeback, Level, Blown advantage, Behind). Like `blunder` it
// lives in the scan's facts (`GameFacts.middlegameResult`), which the filter
// does not read: whoever applies the filter resolves it first into `ids` (the
// game store's `resolveFilter`). Unresolved, it matches no game.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { MIDDLEGAME_RESULTS, type MiddlegameResult } from '@chess/api-model';

const LABEL: Record<MiddlegameResult, string> = {
  ahead: 'Ahead',
  comeback: 'Comeback',
  level: 'Level',
  blown: 'Blown advantage',
  behind: 'Behind',
};

export const middlegameResult: FilterCriterion<'middlegameResult'> = {
  key: 'middlegameResult',
  query: 'middlegame-result',
  many: true,
  parse: oneOf(MIDDLEGAME_RESULTS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 67,
    more: true,
    label: 'Middlegame result',
    options: MIDDLEGAME_RESULTS.map((r) => [r, LABEL[r]] as [MiddlegameResult, string]),
  },
};
